import { HttpService, HttpServiceResponse } from '../shared'
import { LookupsServerData, LookupType } from './lookups.types'

export class LookupsProvider {
  private get url(): string {
    return `${this.baseUrl}/general_lookups_api.php`
  }

  constructor(private http: HttpService, private baseUrl: string) {}

  public get(type: LookupType): Promise<HttpServiceResponse<LookupsServerData>> {
    return this.http.post(`${this.url}?lookupref=${type}`)
  }

  public getWithParams(type: LookupType, params: Object): Promise<HttpServiceResponse<LookupsServerData[]>> {
    return this.http.post(`${this.url}?lookupref=${type}`, params)
  }
}
